import axios from "axios";

export default function getSoSenderList(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/distributor/admin/api/v1/shipping-order/sender`, {
        shipping_order_uuid: uuid,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
